import { Button, Typography, julo } from '@julo-ui/react';
import { BottomSheet } from '@new-components/elements';

interface BottomSheetConfirmationProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const BottomSheetConfirmation = ({
  open,
  onClose,
  onConfirm,
}: BottomSheetConfirmationProps) => {
  return (
    <BottomSheet
      title='Kirim dan konfirmasi data sekarang?'
      display={open}
      onClose={onClose}
      noAction
    >
      <Typography
        type='body'
        color='var(--colors-neutrals-80)'
        sx={{ marginBottom: '16px' }}
      >
        Pastikan kamu sudah mengisi data dengan benar, ya! Karena data tidak
        diubah lagi setelahnya.
      </Typography>
      <julo.div sx={{ display: 'flex', gap: '12px' }}>
        <Button variant='secondary' block onClick={onClose}>
          Periksa Lagi
        </Button>
        <Button variant='primary' block onClick={onConfirm}>
          Kirim
        </Button>
      </julo.div>
    </BottomSheet>
  );
};

export default BottomSheetConfirmation;
